var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRapid7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M7.23392 0.26801C6.79134 0.26801 2.3059 0.26801 1.25771 0.26801C1.34857 0.359048 1.43708 0.452622 1.52006 0.551534C2.19006 1.34969 2.54407 2.35481 2.54407 3.45819C2.54407 5.16101 1.81442 6.69775 0.644531 7.7343H4.30488L6.04198 3.47888H3.86341L4.22872 1.82813H8.55006L6.28015 7.7343C6.28015 7.7343 6.57611 7.7343 7.16798 7.7343C9.24264 7.74736 10.6445 6.05309 10.6445 3.9948C10.6445 1.9366 9.30858 0.26801 7.23392 0.26801Z",
    fill: "#E84C1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapid7);
export default __webpack_public_path__ + "static/media/Rapid7.1854ccf29f96de8742e33342acc02135.svg";
export { ForwardRef as ReactComponent };